import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CompaniesComponent } from "./companies.component";
import { CompanyDetailsComponent } from "./company-details.component";
import { MiproSharedModule } from "@mipro/mipro-shared.module";

const routes = [
    {
        path: "",
        component: CompaniesComponent,
        data: { title: "Companies" }
    },
    {
        path: "edit/:id",
        component: CompanyDetailsComponent,
        data: { title: "Company Details" }
    }
];

@NgModule({
    imports: [ MiproSharedModule,
               RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CompanyRoutingModule {}
